import React, { forwardRef, ComponentProps } from 'react';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.336 2.426a2.33 2.33 0 0 1 .645 4.568v2.82a1.732 1.732 0 0 1-1.725 1.725h-5.29l-2.33 1.903a.585.585 0 0 1-.366.132.621.621 0 0 1-.256-.062.567.567 0 0 1-.326-.52V5.346A1.717 1.717 0 0 1 4.389 3.87h5.792a2.33 2.33 0 0 1 2.155-1.445ZM4.39 5.036a.567.567 0 0 0-.56.568v6.144l1.47-1.242h.045l.086-.086a.423.423 0 0 1 .078-.047.329.329 0 0 1 .117 0h5.616a.56.56 0 0 0 .56-.559V7.022a2.329 2.329 0 0 1-1.777-1.986H4.389Zm-1.718.497a.264.264 0 0 1 0-.108c-.002.036 0 .072 0 .108Z';

const draw24px =
  'M18.145 2.964a3.856 3.856 0 0 1 .723 7.642v4.349a2.651 2.651 0 0 1-2.651 2.65H7.215l-4.01 3.268a.752.752 0 0 1-.463.163.683.683 0 0 1-.307-.068.733.733 0 0 1-.415-.655V7.543A2.652 2.652 0 0 1 4.652 5.19h9.999a3.855 3.855 0 0 1 3.494-2.227ZM4.652 6.636a1.206 1.206 0 0 0-1.206 1.205v10.95l3.094-2.516a.64.64 0 0 1 .261-.116.58.58 0 0 1 .222 0h9.194a1.206 1.206 0 0 0 1.205-1.204v-4.349a3.856 3.856 0 0 1-3.128-3.97H4.652ZM2.01 7.63a.127.127 0 0 0-.01.057v-.058h.01Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SpeechBubbleDottedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'speechBubbleDotted')) as IconWithRender;

SpeechBubbleDottedIcon.displayName = 'SpeechBubbleDottedIcon';
SpeechBubbleDottedIcon.propTypes = Icon.propTypes;
SpeechBubbleDottedIcon.renderIcon = (props) => (
  <SpeechBubbleDottedIcon {...props} />
);

export default SpeechBubbleDottedIcon;
